import { GameCondition, GameLock } from '../../../../_models/Game';
import { Tag } from '../../../../_models/Tag';
import { Tour } from '../../../../_models/Tour';
import { Polygon, PolygonAction } from '../../../../_models/virtualStaging/Polygon';

enum BottomBarIcon {
  Backpack = 'backpack',
}

interface BottomBarProps {
  showBackpackByDefault: boolean;
  isFull: boolean;
  changeFull: () => void;
  onToggleBackpackModal: () => void;
  onToggleHintModal: () => void;
  clickOnTagBackpack: (tag: Tag) => void;
  clickOnPolygonBackpack: (action: PolygonAction) => void;
  clickOnConditionBackpack: (condition: GameCondition) => void;
  tags: Tag[];
  polygons: Polygon[];
  conditions: GameCondition[];
  collectItems: GameLock[];
  tourId: number;
  hintDisable: boolean;
  isRtl: boolean;
  hideBackpack: boolean;

  // from old more bar
  tour: Tour;
  handleToggleMusic: () => void;
  setBackpackNewItems: (ni: number) => void;
  mainPlaying: boolean;
  showBackpack: boolean;
  gameHasStarted: boolean;

  // hub props
  host: any;
  reelVideos: any[];
  onMuteClick: (sid: string) => Promise<void>;
  onFullscreenClick: (sid: string) => Promise<void>;
  onPinClick: (sid: string) => Promise<void>;
  audioOnly: boolean;
  showParticipantsReel: boolean;
  translation: Record<string, string>;
  whiteLabelData: any;
  onHelpClick: () => void;
}

export {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  BottomBarProps,
  BottomBarIcon,
};
